export enum Errors {
  Create = `create-error`,
  Retrieve = `retrieve-error`,
  Update = `update-error`,
}

const supportText = `If this problem persists please reach out to support.`;
export const ErrorToErrorText = {
  [Errors.Create]: `There was an error creating your alert. ${supportText}`,
  [Errors.Retrieve]: `There was an error retrieving your alert. ${supportText}`,
  [Errors.Update]: `There was an error updating your alert. ${supportText}`,
  403: `You do not have permissions to create or update alerts.`,
};

export const ErrorToEventName = {
  [Errors.Create]: `[Alerts] Error Creating Alert`,
  [Errors.Retrieve]: `[Alerts] Error Updating Alert`,
  [Errors.Update]: `[Alerts] Error Retrieving Alerts`,
};
